<template>
  <div class="Contact">
    <div class="title" style="margin-left: 26px">联系我们</div>
    <!-- <div class="pr flex_wrap">
      <ul class="list flex">
				<li class="infotitle">{{ conInfo1.title }}：</li>
				<li>
					<img src="@/assets/img/icon_telephone.png" />
					联系电话：{{ conInfo1.tel }}
				</li>
				<li>
					<img src="@/assets/img/icon_mailbox.png" />
					联系邮箱：{{ conInfo1.email }}
				</li>
			</ul>
      <ul class="list flex">
        <li class="infotitle">{{ conInfo2.title }}：</li>
        <li>
          <img src="@/assets/img/icon_telephone.png" />
          联系电话：{{ conInfo2.tel }}
        </li>
        <li>
          <img src="@/assets/img/icon_mailbox.png" />
          联系邮箱：{{ conInfo2.email }}
        </li>
      </ul>
    </div> -->
    <div class="pr flex_wrap">
      <ul class="list flex">
        <li class="infotitle">{{ conInfo3.title }}：</li>
        <li>
          <img src="@/assets/img/icon_telephone.png" />
          联系电话：{{ conInfo3.tel }}
        </li>
        <li>
          <img src="@/assets/img/icon_address.png" />
          联系地址：{{ conInfo3.address }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data() {
    return {
      // conInfo1: {
      // 	title: '招标/比选咨询 ',
      // 	tel: '020-66289463',
      // 	email: 'liush2@grgtest.com '
      // },
      conInfo2: {
        title: '供应商入库咨询',
        tel: '020-38699960-8766#',
        email: 'gdjlwbhs@grgtest.com'
      },
      conInfo3: {
        title: '公司信息',
        tel: '400-602-0999',
        address: '广州市番禺区石碁镇创运路8号广电计量科技产业园'
      }
    }
  },
  computed: {},
  methods: {}
}
</script>
<style scoped lang="scss">
.Contact {
  margin-top: 30px;
  .title {
    color: #0774c5;
    padding-bottom: 10px;
    border-bottom: 1px dashed #70b0e0;
    font-size: 20px;
  }
  .list {
    padding-left: 25px;
    img {
      margin-right: 15px;
    }
    li {
      margin: 25px 0;
      color: #666;
    }
    .infotitle {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .code_wrap {
    display: inline-block;
    position: absolute;
    right: 0;
    bottom: 20px;
    .codeIcon {
      margin-right: 5px;
    }
    .code {
      width: 120px;
      height: 120px;
      margin-left: 20px;
    }
  }
}
.flex_wrap {
  display: flex;
  justify-content: space-between;
  // width: 80%;
  margin: 0 auto;
}
</style>
